<template>
  <div>
    <card :title="location ? location.name : ''">
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group has-label">
            <label>Datum</label>
            <el-date-picker
              v-model="date"
              format="dd.MM.yyyy"
              value-format="yyyy-MM-dd"
              @change="filterData"
              :clearable="false"
              :picker-options="{ firstDayOfWeek: 1 }"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group has-label">
            <label>Lager</label>
            <multiselect v-model="selectedWarehouses"
              :options="warehouses"
              track-by="id"
              label="short_name"
              :allow-empty="true"
              :close-on-select="true"
              :searchable="true"
              :internal-search="false"
              :clear-on-select="false"
              :multiple="true"
              @input="fetchTableData"
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <product-category-select
            :init-product-categories="productCategories"
            :value="selectedProductCategories"
            @select="productCategorySelected"
            @remove="productCategoryRemoved"
            @deselectAll="selectedProductCategories = []"
          />
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <div class="form-group has-label">
            <label>Ansicht kumuliert nach</label>
            <div>
                <l-radio v-model="viewType" @input="fetchTableData" inline label="variation">Variationen</l-radio>
                <l-radio v-model="viewType" @input="fetchTableData" inline label="product">Produkte</l-radio>
            </div>
          </div>
        </div>
        <div class="col-sm-6 text-right">
          <label>&nbsp;</label>
          <div class="form-group has-label">
            <a :href="downloadUrl" class="btn btn-fill btn-info">
              <i class="fa fa-download"></i>
              Download
            </a>
          </div>
        </div>
      </div>
      <warehouse-products-table
        :products="products"
        :sortable="sortable"
        :hideable-columns="hideableColumns"
        @sortBy="sortBy"
        @filterProductCategory="filterProductCategory"
        :view-type="viewType"
        :product-warehouse-filter-query="warehousesQuery"
      />
      <l-pagination
        background
        layout="prev, pager, next"
        :per-page="10"
        :page-count="pageCount"
        :value="currentPage"
        @input="changePage"
        @changePerPage="changePerPage"
      />
    </card>
  </div>
</template>

<script>
import hasPagination from 'src/has-pagination'
import WarehouseProductsTable from './../../Warehouses/Products/warehouse-products-table'
import ProductCategorySelect from 'src/components/product-category-select'
import { DatePicker } from 'element-ui'
import moment from 'moment'
import api from 'src/api'
import getSortableColumns from './../../Warehouses/Products/get-sortable-columns'
import { Radio as LRadio } from 'src/components'

export default {
  components: {
    LRadio,
    ProductCategorySelect,
    WarehouseProductsTable,
    [DatePicker.name]: DatePicker
  },
  data () {
    return {
      api,
      location: null,
      products: [],
      productCategories: [],
      viewType: 'variation',
      selectedProductCategories: [],
      warehouses: [],
      selectedWarehouses: [],
      date: moment().format('YYYY-MM-DD'),
      sortable: {
        columns: [],
        sortColumn: 'products.name',
        sortOrders: {
          'products.name': 1,
          'product_categories.name': 1,
          'einkaufspreis': 1,
          'products.price': 1,
          'quantity': 1,
          'inventur_quantity': 1,
          'warnschwelle': 1,
          'lager_soll_menge': 1
        }
      },
      hideableColumns: {
        showEkPrice: false,
        showLager: true,
        showLieferanten: false
      }
    }
  },
  mixins: [hasPagination],
  methods: {
    getData (query) {
      this.$http.get(`/locations/${this.$route.params.id}/products?${query}`).then(({ data }) => {
        this.products = data.data.map(stockRotation => ({ ...stockRotation, ...stockRotation.product }))
        this.pageCount = data.last_page
      })
    },
    showProduct (stockRotation) {
      this.$router.push(`/products/${stockRotation.product.id}`)
    },
    filterData () {
      this.currentPage = 1
      this.loading = true
      this.fetchTableData()
    },
    getCustomQueryData () {
      return {
        date: encodeURIComponent(this.date || moment().format('YYYY-MM-DD')),
        'sort-by-column': this.sortable.sortColumn,
        'sort-by-order': this.sortable.sortOrders[this.sortable.sortColumn] > 0 ? 'ASC' : 'DESC',
        'product_categories': this.selectedProductCategories.length ? encodeURIComponent(this.selectedProductCategories.map(({ id }) => id)) : '',
        'warehouses': this.warehousesQuery,
        'view_type': this.viewType
      }
    },
    sortBy (column) {
      this.currentPage = 1
      this.loading = true
      this.sortable.sortColumn = column
      this.sortable.sortOrders[column] = this.sortable.sortOrders[column] * -1
      this.fetchTableData()
    },
    productCategorySelected (category) {
      this.selectedProductCategories.push(category)
      if (category.child_categories.length) {
        this.selectedProductCategories.push(...category.child_categories)
      }
      this.fetchTableData()
    },
    productCategoryRemoved (category) {
      const index = this.selectedProductCategories.findIndex(({ id }) => category.id === id)
      this.selectedProductCategories.splice(index, 1)
      this.fetchTableData()
    },
    filterProductCategory (productCategory) {
      this.selectedProductCategories.push(productCategory)
      this.filterData()
    }
  },
  computed: {
    downloadUrl () {
      return `${api}/locations/${this.$route.params.id}/products/download?${this.getQuery()}`
    },
    warehousesQuery () {
      return this.selectedWarehouses.length ? encodeURIComponent(this.selectedWarehouses.map(({ id }) => id)) : encodeURIComponent(this.warehouses.map(({ id }) => id))
    }
  },
  created () {
    this.$http.get(`/locations/${this.$route.params.id}`).then(({ data }) => {
      this.location = data
      this.warehouses = data.warehouses
      this.selectedWarehouses = data.warehouses
    })
    this.$http.get('/parent_product_categories').then(({ data }) => {
      data.push({ name: 'Ohne Warengruppen', id: '', child_categories: [] })
      this.productCategories = data
    })
    this.fetchTableData()
    this.hideableColumns.showEkPrice = this.$store.getters.isNotFrontdesk
    this.hideableColumns.showLieferanten = this.$store.getters.isNotFrontdesk
    this.sortable.columns = getSortableColumns(this.hideableColumns)
  }
}
</script>
